<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M17.7287 11.1582L10.3866 21.728C10.2856 21.8656 10.1703 21.9498 10.0406 21.9805C9.911 22.0112 9.77966 22.0057 9.64662 21.964C9.50943 21.9181 9.39545 21.843 9.30467 21.7386C9.21389 21.6342 9.16851 21.5029 9.16851 21.3448V15.0008H7.70327C7.23488 15.0008 6.83391 14.8346 6.50036 14.5021C6.16679 14.1697 6 13.77 6 13.3031V3.7851C6 3.28993 6.17478 2.86862 6.52435 2.52117C6.8739 2.17372 7.29402 2 7.78471 2H15.042C15.5004 2 15.8829 2.18494 16.1896 2.55483C16.4962 2.92471 16.5738 3.3348 16.4223 3.7851L14.8147 9.12333H16.7031C17.2267 9.12333 17.6078 9.34886 17.8463 9.79991C18.0849 10.251 18.0457 10.7037 17.7287 11.1582Z"
      fill="currentColor"
    />
  </svg>
</template>
